import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LinkedHeader from 'react/views/generic/LinkedHeader';
import './bookTitle.less';

const BookTitle = ({ title, children, small, catalogLink, uniqueId, featureType, alternativeStyle }) => {
	return (
		<LinkedHeader
			className={classNames("book-title", { "book-title-small": small }, {"novelist-alternative-link-styling": alternativeStyle})}
			title={title}
			featureType={featureType}
			uniqueId={uniqueId}
			catalogLink={catalogLink}
		>
			{children}
		</LinkedHeader>
	);
};

BookTitle.propTypes = {
	children: PropTypes.element.isRequired,
	title: PropTypes.string.isRequired,
	uniqueId: PropTypes.string.isRequired,
	catalogLink: PropTypes.object,
	small: PropTypes.bool,
	closeModal: PropTypes.func
};

export default BookTitle;



// WEBPACK FOOTER //
// ./src/react/views/bookTitle/BookTitle.jsx